import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import MoreProductsScene from '../3D/MoreProductsScene';

// page-more-products: pàgina que NOMÉS té thumbnails (blocs block_more_products). Té la seva
// pròpia escena WebGL (MoreProductsScene), seguint el patró Home→HomeScene / Product→ProductScene.
// Estén Default → mateixa entrada/sortida que la resta de pàgines (Wrap show/hide, hideCharacter/
// hideBGSphere). El reveal de la grid el dispara ScrollItem__BlockMoreProducts en fer scroll.
export default class MoreProducts extends Default {
  constructor() {
    super();
    // categ opcional des del data-type de la pàgina (layer del marc glass); si no, null.
    MoreProductsScene.init(this.container);
  }

  loop() {
    super.loop();
    MoreProductsScene.loop();
  }

  afterHide() {
    MoreProductsScene.dispose();
    super.afterHide();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    MoreProductsScene.resize();
  }
}

ControllerPage._addPage('page-more-products', MoreProducts);
